<template>
  <div class="column is-half">
    <div class="document-container columns">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRequisite(object.id)"/>
      <div class="input-data">
        <Editor :editorToolbar="customToolbar" :id="'id_' + object.id" v-model="text" @blur="handleUpdate" @click/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VueEditor as Editor } from 'vue2-editor'

export default {
  name: 'RequisiteItem',
  data () {
    return {
      updateTimer: null,
      customToolbar: [
        ['bold', 'italic', 'underline', 'link'],
         [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{'list': 'ordered'}, {'list': 'bullet'}]
      ],
      text: ''
    }
  },
  created () {
    this.text = this.object.text
  },
  watch: {
    text () {
      this.handleUpdate()
    }
  },
  props: {
    object: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteRequisite', 'updateRequisite']),
    handleUpdate () {
      this.object.text = this.text
      this.updateRequisite(this.object)
    }
  },
  components: { Editor }
}
</script>

<style scoped>
.document-container {
  background: #eee;
  padding: 20px;
  margin: 5px;
}
.document-wrapper {
  padding: 15px;
}
.delete-icon {
  margin: 0 20px 0 0;
  height: 28px;
  width: 28px;
  position: initial;
}
.input-data {
  width: 100%;
}
.control {
  margin: 0 0 12px;
}
.quillWrapper {
  background: #fff;
}
</style>
<style>
.requisites .quillWrapper .ql-container {
  height: 300px !important;
}
</style>



// WEBPACK FOOTER //
// RequisiteItem.vue?634d4423